<!-- 左边菜单 -->
<template>
    <div class="page_left">
		<el-menu
			default-active="2"
			class="el-menu-vertical-demo"
			@open="handleOpen"
			@close="handleClose"
			background-color="#545c64"
			text-color="#fff"
			:unique-opened="true"
			active-text-color="#ffd04b">
			<el-submenu :index="listValue.pageLink" v-for="(listValue,listKey) in menuList" :key="listKey" >
				<template slot="title">
					<span>{{listValue.name}}</span>
				</template>
				<el-menu-item-group v-for="(listTwoValue,listTwoKey) in listValue.list" :key="listTwoKey">
					<el-menu-item :index="listTwoValue.pageLink"  @click="$common.pageJump(listTwoValue.pageLink)">{{listTwoValue.name}}</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
		</el-menu>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'pageMenu',
	props:['pageModel'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            menuList:[],
			
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		selectMenuList(){
			var saveMenuList = []
			if(sessionStorage.getItem('saveMenuList')){
				saveMenuList = JSON.parse(sessionStorage.getItem('saveMenuList'))
			}
			console.log(saveMenuList);
			var menuList = this.$store.state.menuList
			menuList.forEach((menuOneValue,menuOneKey)=>{
				menuOneValue.list.forEach((menuTwoValue,menuTwoKey)=>{
					menuTwoValue.list.forEach((menuThreeValue,menuThreeKey)=>{
						if(this.$route.path == menuThreeValue.pageLink){
							menuOneValue.pageLink = menuThreeValue.pageLink
							if(saveMenuList.length>0){
								var isSaveMenu = true
								saveMenuList.forEach((saveValue,saveKey)=>{
									if(saveValue.menuId == menuOneValue.menuId){
										isSaveMenu = false
									}
								})
								
								if(isSaveMenu==true){
									saveMenuList.push(menuOneValue)
								}
							}else{
								saveMenuList.push(menuOneValue)
							}
							this.menuList = menuOneValue.list
							
						}
					})
				})
			})
			
			
			sessionStorage.setItem('saveMenuList',JSON.stringify(saveMenuList))
		},
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
		this.selectMenuList()
		// this.$common.console(this.pageModel)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
		// this.selectMenuList()
    },
    beforeCreate() {
		
		this.$common.console('创建之前')
	}, //生命周期 - 创建之前
    beforeMount() {
		this.$common.console('创建之前')
	}, //生命周期 - 挂载之前
    beforeUpdate() {
		this.$common.console('更新之前')
		// this.selectMenuList()
		// console.log(123)
	}, //生命周期 - 更新之前
    updated() {
		// this.selectMenuList()
		this.$common.console('更新之后')
	}, //生命周期 - 更新之后
    beforeDestroy() {
		
		this.$common.console('销毁之前')
	}, //生命周期 - 销毁之前
    destroyed() {
		this.$common.console('销毁完成')
	}, //生命周期 - 销毁完成
    activated() {
		// this.$common.console('keep-alive缓存')
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>

</style>